import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useDashboardSummary } from '../hooks/useDashboardData';
import type { DashboardFilters } from '../types/dashboard.types';

interface StatsCardsProps {
  filters?: DashboardFilters;
}

export const StatsCards: React.FC<StatsCardsProps> = ({ filters }) => {
  const { data: summary, isLoading, error } = useDashboardSummary(filters);

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="animate-pulse">
            <CardContent className="p-6">
              <div className="h-20 bg-gray-200 rounded"></div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (error || !summary) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="border-red-200">
          <CardContent className="p-6 text-center text-red-600">
            Error al cargar estadísticas
          </CardContent>
        </Card>
      </div>
    );
  }

  const stats = [
    {
      title: 'ALOJAMIENTOS',
      value: summary.count?.toLocaleString() || '0',
      color: 'text-red-500',
      borderColor: 'border-red-500',
      withoutData: undefined,
    },
    {
      title: 'PLAZAS',
      value: summary.totalPlaces?.toLocaleString() || '0',
      color: 'text-blue-500',
      borderColor: 'border-blue-500',
      withoutData: summary.withoutPlaces,
    },
    {
      title: 'HABITACIONES',
      value: summary.totalRooms?.toLocaleString() || '0',
      color: 'text-cyan-500',
      borderColor: 'border-cyan-500',
      withoutData: summary.withoutRooms,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {stats.map((stat) => (
        <Card key={stat.title} className={`border-2 ${stat.borderColor}`}>
          <CardContent className="p-6 text-center">
            <div className={`text-4xl font-bold ${stat.color} mb-2`}>
              {stat.value}
            </div>
            <div className="text-sm text-gray-600 font-medium uppercase tracking-wide">
              {stat.title}
            </div>
            {!!stat.withoutData && (
              <div className="text-xs text-gray-500 mt-1">
                {stat.withoutData.toLocaleString()} sin dato
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};